import React from 'react';
import SVG from '@atlaskit/icon/svg';
import type { SVGProps } from '@atlaskit/icon/types';

export const DockIcon = ({ primaryColor, size, label }: SVGProps) => (
	<SVG primaryColor={primaryColor} size={size} label={label}>
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
			<rect width="16" height="2" x="4" y="18" fill="currentColor" rx="1" />
		</svg>
	</SVG>
);
